export default __webpack_public_path__ + "static/media/discordNoLogo.b6bf97fe.png";